import { IColumn } from '@private/data-grid';

import { GENERAL } from 'constants/common';
import { IFilterSetting } from 'utils/types';

import { IGetGridConfigs, IGetGridConfigsResult } from './types';

export const getGridConfigs = <T>({
  columns,
  disabledColumns,
  filters,
}: IGetGridConfigs<T>): IGetGridConfigsResult<T> => {
  const gridColumns: IColumn<T>[] = [];
  const filtersMap = new Map<string, Map<string, IFilterSetting>>();
  const sectionsFiltersMap: Record<string, string> = {};

  columns.forEach((column) => {
    if (disabledColumns?.includes(column.dataKey as string) || column.hidden) {
      column.hideColumn = true;
    }

    const { sectionName = GENERAL, ...restColumnSettings } = column;
    const { dataKey } = restColumnSettings;
    gridColumns.push(restColumnSettings);
    const filter = filters?.[dataKey as keyof typeof filters];

    if (!filter) {
      return;
    }

    if (filtersMap.has(sectionName)) {
      const sectionList = filtersMap.get(sectionName);
      if (sectionList) {
        sectionList.set(dataKey as string, filter);
      }
    } else {
      const newSectionMap = new Map();
      newSectionMap.set(dataKey, filter);
      filtersMap.set(sectionName, newSectionMap);
    }

    sectionsFiltersMap[dataKey as string] = sectionName;
  });

  return {
    columns: gridColumns,
    gridFilters: filtersMap,
    sectionsFiltersMap,
  };
};
